/**
 * Season of Gifting campaign identifier. Must match `Gifting::CAMPAIGN` in
 * the Rails repo — it's the signup param the server checks before treating
 * a signup as a campaign signup. One constant, never a second spelling.
 */
export const GIFTING_CAMPAIGN = 'season-of-gifting-2026';

/** MarketPryce Rewards on the App Store (ASC app 6767093791). */
export const APP_STORE_URL =
  'https://apps.apple.com/us/app/marketpryce-rewards/id6767093791';

/**
 * Fallback for the server's five identity strings (lib/campaignCopy merges
 * per-field) — used only when the payload predates gifting_copy /
 * campaign_copy. Verbatim from Jason's copy doc (2026-08); must match the
 * backend's Gifting::COPY at ship time.
 */
export const CAMPAIGN_COPY_FALLBACK = {
  name: 'Back-to-School Campus Drop',
  headline: 'New semester. New NIL deal.',
  subhead:
    'We convinced some of our favorite brands to send free products to college athletes ' +
    'because we believe the best NIL partnerships start with a great product, not a contract.\n\n' +
    'Pick one brand you’d genuinely be excited to try. There’s no required post. Just try the ' +
    'product, see what you think, and start building a relationship if you love it.',
  cta_label: 'Claim my free gift',
  share_text: 'I just claimed a free gift on MarketPryce. Claim yours too:',
} as const;
